import * as React from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

interface SaveTemplateDialogProps {
    open: boolean;
    handleClose: () => void;
    saveTemplate: (value: string) => void;
}

const SaveTemplateDialog: React.FC<SaveTemplateDialogProps> = ({
    open,
    handleClose,
    saveTemplate,
}) => {
    const [templateName, setTemplateName] = React.useState<string>('');
    const handleNameChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setTemplateName(event.target.value);
    };

    const handleSave = () => {
        saveTemplate(templateName);
        setTemplateName('');
        handleClose();
    };

    const handleCancel = () => {
        setTemplateName('');
        handleClose();
    };

    return (
        <Dialog open={open} onClose={handleClose} key={'save_template_dialog'}>
            <DialogTitle>Save as New Template</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    To save this filter combination as a new template, please
                    provide a name. By saving this combination as a template,
                    you can quickly reapply these filters in the future without
                    having to manually select each one again.
                </DialogContentText>
                <TextField
                    autoFocus
                    required
                    margin="dense"
                    id="savedTemplateName"
                    name="templateName"
                    label="Template Name"
                    fullWidth
                    variant="outlined"
                    onChange={handleNameChange}
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={handleCancel}>Cancel</Button>
                <Button onClick={handleSave} variant={'contained'}>
                    Save
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default SaveTemplateDialog;
